<template>
  <div>
    <SnackbarComponent v-model="snackbar.show" :message="snackbar.message" :color="snackbar.color" />
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h6 pa-4">Mark Case Resolved</v-card-title>
        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <div class="text-body-1">
            Are you sure you want to mark
            <strong>{{ ticket?.caseId || ticket?.ticketId }}</strong>
            as resolved?
          </div>
          <div class="text-caption text-medium-emphasis mt-2">
            This will close the case for the reporter.
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="text" @click="handleClose" :disabled="loading">
            Cancel
          </v-btn>
          <v-btn color="primary" variant="flat" :loading="loading" @click="handleResolve">
            Mark resolved
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SnackbarComponent from "@/components/Extras/Snackbar.vue";
import { edit_ticket } from "@/graphql/mutations";
import { generateClient } from "aws-amplify/api";

export default {
  name: "ResolveTicket",
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    ticket: {
      type: Object,
      default: null,
    },
  },
  emits: ["update:modelValue", "resolved"],
  data() {
    return {
      loading: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    handleClose() {
      this.dialog = false;
    },
    async handleResolve() {
      if (!this.ticket?.ticketId && !this.ticket?.ticket_id) return;

      this.loading = true;

      try {
        const input = {
          ticket_id: this.ticket.ticketId || this.ticket.ticket_id,
          ticket_status: "RESOLVED",
        };

        const client = generateClient();
        const response = await client.graphql({
          query: edit_ticket,
          variables: {
            input,
          },
        });

        let responseData = response.data.edit_ticket;
        if (typeof responseData === "string") {
          responseData = JSON.parse(responseData);
        }

        if (responseData.status != "SUCCESS") {
          throw new Error(responseData.status_message || "Failed to mark resolved");
        }

        this.snackbar = {
          show: true,
          message: "The case has been resolved",
          color: "success",
        };

        this.$emit("resolved", this.ticket);
        this.dialog = false;
      } catch (error) {
        this.snackbar = {
          show: true,
          message: error?.message || "Failed to mark the case as resolved",
          color: "error",
        };
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>
